// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.css-dip3t8{
  width: 200px !important;
  background-color: #07070E !important;
  color: #BBBCBD!important;
  height: 90vh !important;
  overflow-y: scroll;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{
  color: #666666 !important;
  background: #919191 !important;
  border: 1px solid #999999 !important;

}

.ps-menu-root{

  background-color: none !important;
}

.css-ewdv3l{
  background-color: #07070E !important;
}

.ps-sidebar-container{
  background-color: none !important;
}
.ps-menu-root{
  background-color: none !important;
}

.css-16jesut >.ps-menu-button:hover{
  background-color: #07070E !important;
}
.css-1wvake5{
  
  border: none !important;
}

.css-x3jz15 >.ps-menu-button:hover{
  background-color: #07070E !important;
}

.css-1ffbfs >.ps-menu-button:hover{
  background-color: #07070E !important;
}

.css-1t8x7v1 >.ps-menu-button:hover{
  background-color: #07070E !important;
}

.css-1tqrhto >.ps-menu-button:hover{
  background-color: #07070E !important;
}


.contentss button{
  background-color: #282B30;
  border: 1px solid #BBBCBD;
}
.selected-item {
  background-color: #4996EE; 
  color: white; 
}
.default-class:hover{
  background-color: #06315f; 
  color: white; 
}

`, "",{"version":3,"sources":["webpack://./src/components/DropDown/Dropdown.css"],"names":[],"mappings":";;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;;AAEtC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;AACA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;;AAGA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;AACd","sourcesContent":["\n\n.css-dip3t8{\n  width: 200px !important;\n  background-color: #07070E !important;\n  color: #BBBCBD!important;\n  height: 90vh !important;\n  overflow-y: scroll;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{\n  color: #666666 !important;\n  background: #919191 !important;\n  border: 1px solid #999999 !important;\n\n}\n\n.ps-menu-root{\n\n  background-color: none !important;\n}\n\n.css-ewdv3l{\n  background-color: #07070E !important;\n}\n\n.ps-sidebar-container{\n  background-color: none !important;\n}\n.ps-menu-root{\n  background-color: none !important;\n}\n\n.css-16jesut >.ps-menu-button:hover{\n  background-color: #07070E !important;\n}\n.css-1wvake5{\n  \n  border: none !important;\n}\n\n.css-x3jz15 >.ps-menu-button:hover{\n  background-color: #07070E !important;\n}\n\n.css-1ffbfs >.ps-menu-button:hover{\n  background-color: #07070E !important;\n}\n\n.css-1t8x7v1 >.ps-menu-button:hover{\n  background-color: #07070E !important;\n}\n\n.css-1tqrhto >.ps-menu-button:hover{\n  background-color: #07070E !important;\n}\n\n\n.contentss button{\n  background-color: #282B30;\n  border: 1px solid #BBBCBD;\n}\n.selected-item {\n  background-color: #4996EE; \n  color: white; \n}\n.default-class:hover{\n  background-color: #06315f; \n  color: white; \n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
